export const DATA_FILES_CONFIG = [
  {
    label: 'Stores',
    value: 'stores',
  },
  {
    label: 'Customers',
    value: 'customers',
  },
  {
    label: 'Transactions',
    value: 'transactions',
  },
  {
    label: 'Products',
    value: 'products',
  },
  {
    label: 'Orders',
    value: 'orders',
  },
  {
    label: 'Shipping',
    value: 'shipping',
  },
  {
    label: 'Kpi Metrics',
    value: 'kpi_metrics',
  },
];
